const data: any = [{"key":"redirect-toast","copy":"Please look in the menu for the new location of your Bill Pay Service."}];
export default data